/* eslint-disable */
let appConfig = {
	// load=package.standard вместо дефолтного package.full намеренно исключает модуль панорам:
	// у Яндекса появились лимиты на «показы панорам» и за их превышение блокируются карты.
	// Без панорам в typeSelector нет пункта «Панорамы», плеер панорам не загружается — показы не начисляются.
	// package.standard содержит всё, что используется в проекте (Map, Clusterer, Placemark, GeoObjectCollection, контролы).
	yamapsUrl: 'https://api-maps.yandex.ru/2.1/?apikey=fd21f65c-506d-45d8-9cfe-18c5ad8d4173&lang=ru_RU&load=package.standard',
	marketingClientConfig: {
		apiGatewayUrl: window.appConfig?.apiGatewayUrl,
	}
};

export default appConfig;